import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Form, Input, Modal, message, Button, Row, Col,
} from 'antd';
import {
  driverClusterEdit,
  fetchOptions,
  fetchOptionsLike,
} from '../ducks';
import Select from '../../components/Select';

function DriverClusterUpdateModal({
  editModalVisibility,
  setEditModalVisibility,
  rowDetails,
  setRowDetails,
  tableFilter,
  onTableUpdate,
  branchCodeList,
  openModal,
  ...props
}) {
  const {
    form,
    doDriverClusterEdit,
    doFetchOptions,
  } = props;
  const { getFieldDecorator, setFieldsValue } = form;
  const [vehicles,setVehicles] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isFetching,setIsFetching] = useState(false);
  useEffect(() => {
    
      if(editModalVisibility){
        doFetchOptions('vehicle').then((res)=>{
        let vehicles = res.payload.data;
        let start = 0;
        for(let i = 0; i < vehicles.length; i++){
          if(rowDetails.vehicle_id == vehicles[i].value){
            start = i;
            break;
          }
        }
        setVehicles(prevState => (res.payload.data.slice(start, start + 50)));
        if(rowDetails){
          props.form.setFieldsValue({
            cluster:rowDetails.cluster,
            vehicle:rowDetails.vehicle_id,
            maximum_tn:rowDetails.maximum_tn,
            maximum_cwt: rowDetails.maximum_cwt,
            minimum_cwt: rowDetails.minimum_cwt,
            prio: rowDetails.prio
          });
        }
      });
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editModalVisibility]);

    const searchOption = (type, e) => {
    const { doFetchOptionsLike } = props;

    setIsFetching({
      isFetching: true,
    });

    doFetchOptionsLike(type, e).then((action) => {
      setIsFetching(false);
    if(type === 'vehicle'){
        setVehicles(prevState => (action.payload.data.slice(0, 50)));
      }
    });
  }
  function UpdateData(id) {
    const { validateFields } = form;
    setIsUpdating(true);
    
    validateFields((err, values) => {
      if (!err) {
        values['id'] = rowDetails.id;
        console.log(values);
        doDriverClusterEdit(values).then((res) => {
          message.success(res.payload.data.message);
          onTableUpdate({
            ...tableFilter,
            page: tableFilter.page - 1,
          });
          setIsUpdating(false);
        }).catch((resErr) => {
          // let errorMessage;
          if (resErr.error.response.status === 422) {
            // const index = Object.values(resErr.error.response.data);

            // eslint-disable-next-line prefer-destructuring
            // errorMessage = index[0]['barangay'];

            message.error(resErr.error.response.data.message, 3);
          }
          setIsUpdating(false);
        });
      } else {
        setIsUpdating(false);
      }
    });
  }

  useEffect(() => {
    setFieldsValue({
      branch: rowDetails.branch,
      cluster: rowDetails.cluster,
      route_code: rowDetails.route_code,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editModalVisibility]);


  return (
    <Modal
      title={`Port Cluster Edit - #${rowDetails.id}`}
      closable={false}
      visible={editModalVisibility}
      afterClose={() => {
        setRowDetails({
          id: null,
          name: '',
          code: '',
        });
      }}
      footer={[
        <Button
          key="back"
          onClick={() => {
            setEditModalVisibility(false);
          }}
        >
          Cancel
        </Button>,
        <Button
          type="primary"
          loading={isUpdating}
          onClick={() => { UpdateData(rowDetails.id); }}
        >
          Update
        </Button>,
      ]}
    >
      <Form>
        <Row gutter={12}>
          <Col xs={24} sm={8} lg={8}>
            <Form.Item label="Cluster">
              {getFieldDecorator('cluster', {
                rules: [{
                  required: true,
                  message: 'Cluster field is required',
                }],
              })(<Input autoComplete="off" />)}
            </Form.Item>
          </Col>

          <Col xs={24} sm={8} lg={8}>
            <Form.Item label="Vehicle">
              {getFieldDecorator('vehicle', {
                rules: [
                  {
                    required: true,
                    message: 'Vehicle field is required',
                  },
                ],
                initialValue: rowDetails.vehicle_id, 
              })(<Select
                    allowClear
                      loading={isFetching}
                      options={vehicles}
                      onSearch={e => searchOption('vehicle', e)}
                      filterOption={false}
                      placeholder="Type to search for desired vehicle"
                      name="vehicle"
                      showSearch  
              />)}
            </Form.Item>
          </Col>
          <Col xs={24} sm={8} lg={8}>
            <Form.Item label="Maximum TNs">
              {getFieldDecorator('maximum_tn', {
                rules: [
                  {
                    required: true,
                    message: 'Maximum TNs field is required',
                  },
                ],
                initialValue: rowDetails.maximum_tn
              })(<Input autoComplete="off" />)}
            </Form.Item>
          </Col>
          <Col xs={24} sm={8} lg={8}>
            <Form.Item label="Minimum CWT">
              {getFieldDecorator('minimum_cwt', {
                rules: [
                  {
                    required: true,
                    message: 'Minimum CWT field is required',
                  },
                ],
                initialValue: rowDetails.minimum_cwt
              })(<Input autoComplete="off" />)}
            </Form.Item>
          </Col>
          <Col xs={24} sm={8} lg={8}>
            <Form.Item label="Maximum CWT">
              {getFieldDecorator('maximum_cwt', {
                rules: [
                  {
                    required: true,
                    message: 'Maximum CWT field is required',
                  },
                ],
                initialValue: rowDetails.maximum_cwt
              })(<Input autoComplete="off" />)}
            </Form.Item>
          </Col>
          <Col xs={24} sm={8} lg={8}>
            <Form.Item label="Prio">
              {getFieldDecorator('prio', {
                rules: [
                  {
                    required: true,
                    message: 'Prio field is required',
                  },
                ],
                initialValue: rowDetails.prio
              })(<Input autoComplete="off" type='number' />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>

  );
}

DriverClusterUpdateModal.propTypes = {
  form: PropTypes.oneOfType([PropTypes.object]).isRequired,
  doDriverClusterEdit: PropTypes.func.isRequired,
  editModalVisibility: PropTypes.bool.isRequired,
  setEditModalVisibility: PropTypes.func.isRequired,
  rowDetails: PropTypes.oneOfType([PropTypes.object]).isRequired,
  setRowDetails: PropTypes.func.isRequired,
  tableFilter: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  branchCodeList: PropTypes.oneOfType([PropTypes.array]).isRequired,
  onTableUpdate: PropTypes.func.isRequired,
  doFetchOptionsLike: PropTypes.func.isRequired,
  doFetchOptions: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  doFetchOptions: fetchOptions,
  doFetchOptionsLike:fetchOptionsLike,
  doDriverClusterEdit: driverClusterEdit,
};

const WrappedPortCluseterUpdateModal = Form.create({ name: 'DriverClusterUpdateModal' })(DriverClusterUpdateModal);

export default connect(null, mapDispatchToProps)(WrappedPortCluseterUpdateModal);
